import { http } from './http';

export interface AnalyzeResult {
  headers: string[];
  sample: string[][];
  totalRows: number;
}

export interface ImportJobStatus {
  jobId: string;
  status: 'running' | 'done' | 'error';
  totalRows: number;
  processedRows: number;
  insertedRows: number;
  errorRows: number;
  errorMessage?: string;
  sampleErrors: string[];
  startedAt: string;
  finishedAt?: string;
}

export const importApi = {
  analyze: (connectionId: string, file: File): Promise<AnalyzeResult> => {
    const form = new FormData();
    form.append('file', file);
    return http.post(`/import/${connectionId}/analyze`, form).then(r => r.data);
  },

  start: (connectionId: string, file: File, schema: string, table: string, columnMapping: Record<string, string>, fixedValues: Record<string, string> = {}, defaultValues: Record<string, string> = {}): Promise<{ jobId: string }> => {
    const form = new FormData();
    form.append('file', file);
    for (const [fileCol, tableCol] of Object.entries(columnMapping))
      if (tableCol) form.append(`map[${fileCol}]`, tableCol);
    for (const [tableCol, value] of Object.entries(fixedValues))
      form.append(`fixed[${tableCol}]`, value);
    for (const [fileCol, defVal] of Object.entries(defaultValues))
      if (defVal !== '') form.append(`nullval[${fileCol}]`, defVal);
    return http.post(`/import/${connectionId}/start`, form, { params: { schema, table } }).then(r => r.data);
  },

  getJob: (jobId: string): Promise<ImportJobStatus> =>
    http.get(`/import/jobs/${jobId}`).then(r => r.data),

  suggestMapping: (
    fileHeaders: string[],
    sampleRows: string[][],
    tableColumns: { name: string; dataType: string; nullable: boolean }[]
  ): Promise<{ mapping: Record<string, string>; aiUsed: boolean }> =>
    http.post('/import/suggest-mapping', { fileHeaders, sampleRows, tableColumns })
      .then(r => r.data),
};
